"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesizeLimitIndicator = void 0;
var react_1 = __importDefault(require("react"));
var filesize_1 = __importDefault(require("filesize"));
require("./FilesizeLimitIndicator.scss");
var utils_1 = require("@app/shared/utils");
var FilesizeLimitIndicator = function (props) {
    var maxSizeInBytes = utils_1.megabytesToBytes(props.maxSize);
    var exceededLimit = props.currentSize >= maxSizeInBytes;
    var exceededLimitElement = exceededLimit ?
        react_1.default.createElement("span", { className: "help icon is-danger" },
            react_1.default.createElement("i", { className: "fas fa-exclamation-triangle" })) : null;
    return (react_1.default.createElement("div", { className: "filesize-limit-indicator" },
        react_1.default.createElement("div", { className: "level" },
            react_1.default.createElement("div", { className: "level-left is-size-5" }, "Package Contents"),
            react_1.default.createElement("div", { className: "level-right is-size-5" }, props.maxSize > 0 &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    exceededLimitElement,
                    filesize_1.default(props.currentSize),
                    " of ",
                    filesize_1.default(maxSizeInBytes))))));
};
exports.FilesizeLimitIndicator = FilesizeLimitIndicator;
